import { connect } from "react-redux";
import Header from "../Header";
import DocumentList from "../Dashboard/DocumentList";
import { useNavigate } from "react-router-dom";

const UserDocuments = ({ documentList }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="container-fluid container-fluid-login">
        <Header />
        <div className="row">
          <div className="col-md-12 p-4 bg-white">
            <h2>{documentList?.userDetail?.firstName} {documentList?.userDetail?.lastName}</h2>
            <p>
              Listed below are forms, documents and videos that have been
              assigned to him.
            </p>
            <p>His progress will be saved automatically.</p>
            <p><button className="btn bt-sm btn-light text-primary" onClick={() => {
              navigate("/dashboard")
            }}>Go Back</button></p>
          </div>
          <div>
            <DocumentList />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  documentList: state.user.documentList,
});

export default connect(mapStateToProps, {})(UserDocuments);
